import SbTable from './src/table.vue'

export default SbTable
